import React from 'react';
import TextBlock from 'components/common/helpMeDecide/TextBlock';
import withCriteria from 'components/common/helpMeDecide/withCriteria';
import { RadioGroup } from '@insurancemenu/imenu-components-lib';
import { createStyles } from 'components/common/helpMeDecide/commonCriteriaStyles';
import { observer } from 'mobx-react-lite';
import { useRootStore } from 'store/rootStore';

const MedicalCriteria1 = observer((): JSX.Element => {
  const classes = createStyles();

  // Mobx store
  const {
    browsingFilterStore: { onBrowsingCriteriaChange, getBrowsingCriteriaValue },
  } = useRootStore();
  const bcName = 'insuranceType_FILTER';

  // Values for radio buttons group
  const radioButtons = [
    {
      id: 'PPO',
      label: 'Willing to pay extra for the widest network or choice of doctors',
      value: 'PPO',
    },
    {
      id: 'HMO',
      label: 'Show me lower priced plans with smaller network of doctors',
      value: 'HMO',
    },
  ];

  return (
    <div>
      <TextBlock
        title="Insurance Type"
        subtitle="Do you want to prioritize the widest possible network or would you consider a smaller network of doctors to lower costs?"
      />
      <RadioGroup
        label=""
        value={getBrowsingCriteriaValue(bcName)}
        radioButtons={radioButtons}
        className={classes.radioButtonGroup}
        onChange={(e: React.ChangeEvent<HTMLInputElement>): void => {
          onBrowsingCriteriaChange(bcName, e.target.value);
        }}
      />
    </div>
  );
});

export default withCriteria(MedicalCriteria1, 1);
